import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-calendar-expandable-in-out-picker",
  templateUrl: "./calendar-expandable-in-out-picker.component.html",
  styleUrls: ["./calendar-expandable-in-out-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarExpandableInOutPickerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
